module.exports = __webpack_public_path__ + "pstatic/img/report4.28676e15.png";